import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import {GoogleMap, MapType, Marker} from '@capacitor/google-maps'
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import {Geolocation} from '@capacitor/geolocation'
import { PlatformService } from 'src/app/platform.service';
import { Capacitor } from '@capacitor/core';
import { DataService } from 'src/app/services/data.service';
import { Chart,registerables  } from 'chart.js';
import SwiperCore, { SwiperOptions,Navigation,Pagination } from 'swiper';
import { map } from 'rxjs/operators';
SwiperCore.use([Navigation,Pagination ]);
import { Browser } from '@capacitor/browser';
import { QrcodePermitPage } from 'src/app/modals/qrcode-permit/qrcode-permit.page';
import { Location } from "@angular/common";
import { TranslateService } from '@ngx-translate/core';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { get } from 'scriptjs';
import { EnterlotpasswordPage } from 'src/app/pages/enterlotpassword/enterlotpassword.page';
@Component({
  selector: 'app-realtimeparking',
  templateUrl: './realtimeparking.component.html',
  styleUrls: ['./realtimeparking.component.scss'],
})
export class RealtimeparkingComponent implements OnChanges,AfterViewInit   {
  environment = environment
  mapsApiKey;
  disableHourly = true;
  disableDaily = true;
  permitType ='hourly'
  @Input() refresh?
  width = window.innerWidth;
  height = window.innerHeight;
  loaded=false
  @ViewChild('myChart') private barCanvas: ElementRef;
  markers;
  lots;
   options:PositionOptions={
    enableHighAccuracy:false,
    timeout:10000,
    maximumAge:0
  }
  chart: any;
  selectedLot
  @ViewChild('map')mapRef:ElementRef;
  map:GoogleMap;
  cardsConfig: SwiperOptions = {
    
    slidesPerView: 1.15,
    centeredSlides:true
  };
  color='#fff'
  webMapStyles = [
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    }
  ]
  nativeMapStyles = [
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    }
  ]
  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    public platform: Platform,
    private errorHandlerSRV:ErrorHandlerService,
    private translate: TranslateService,
    private alertCtrl: AlertController,
    private dataSRV:DataService,
    private location: Location,
    public platformSRV:PlatformService,
    private modalCtrl:ModalController,
    public translateService: TranslateService,
  ) { 
    Chart.register(...registerables);
    if(window.location.hostname === 'localhost'){
      this.mapsApiKey = environment.devMapsKey
    }
    else if(!Capacitor.isNativePlatform()){
      this.mapsApiKey = environment.webMapsKey
    }
    else if(this.platform.is('ios')){
      this.mapsApiKey = environment.iosMapsKey
    } 
    else if (this.platform.is('android')){
      this.mapsApiKey = environment.androidMapsKey
    }
    
    
    
  }
  onSectionChange(event) {
   
    this.permitType = event.detail.value;
  }
  async showIconLegend(){
    let alert = await this.alertCtrl.create({
      header:this.translateService.instant('keys.data.permits.icon_legend') || 'Icon Legend',
      message: '<ion-item><img src="https://tomahawku.preview.ops-com.com/images/parking/icons/parking-sign-40-green.png"><ion-label>Many parking spots are available.</ion-label></ion-item><ion-item><img src="https://tomahawku.preview.ops-com.com/images/parking/icons/parking-sign-40-yellow.png"><ion-label>Some parking spots are available.</ion-label></ion-item>     <ion-item><img src="https://tomahawku.preview.ops-com.com/images/parking/icons/parking-sign-40-red.png"><ion-label>No parking spots are available.</ion-label></ion-item>',
      backdropDismiss:false
    ,
    cssClass:'icon-legend-class',
      buttons: [
       
        {
          text: this.translateService.instant('keys.data.common.close') || 'Close',
          handler: () => {
            
          }
        }
      ]
    });
    alert.present();
  }
  async showAlert(){
    
    let alert = await this.alertCtrl.create({
      header: this.translateService.instant('keys.data.permits.location_permission') || 'Location Permission',
      message: this.translateService.instant('keys.data.permits.location_prompt') || 'Make sure location is enabled before accessing this page',
      backdropDismiss:false
      
    ,
      buttons: [
       
       
        {
          text: this.translateService.instant('keys.data.common.continue') || 'Continue',
          cssClass:'location-permission1',
          handler: () => {
            this.loadData()
          }
        },
        {
          text: this.translateService.instant('keys.data.common.back') || 'Back',
          cssClass:'location-permission2',
          handler: () => {
            this.location.back();
          }
        }
      ]
    });
    alert.present();
  }
  
  
  async BookNow(lot){
    
    var data ={
      id:lot.id,
      lotPasswordEnabled:lot.password_enabled,
      isModal:true
    }
    
    const desktopModal = await this.modalCtrl.create({
      component: QrcodePermitPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass: 'modal-desktop-long',
      componentProps:{
        ...data
      }
    });
    const mobileModal = await this.modalCtrl.create({
      component: QrcodePermitPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass:"modal-mobile-normal",
      componentProps:{
        ...data
      }
    })
    const tabletModal = await this.modalCtrl.create({
      component: QrcodePermitPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1, 
      cssClass:"modal-tablet-normal",
      componentProps:{
        ...data
      }
    })
    var modal = await this.dataSRV.getModalType(mobileModal, tabletModal, desktopModal)
    
    await modal.present()
      
    
   
    
    
   
  }
  async openInMaps(){
    
    await Browser.open({url:`https://www.google.com/maps/place/${this.selectedLot.lat + ',' + this.selectedLot.lng}`})
   
  }
  ngOnDestroy() {
    
   if(this.map!=undefined){
    
    this.map.removeAllMapListeners();
    this.map.destroy();
   
    
   }
   if(this.chart!=undefined){
    this.chart.destroy()
   }
   this.color='#fff'
   this.loaded=false
  }
  scrollToTop(){
    const element = document.getElementById("hour1");
    element.scrollIntoView({ behavior: "smooth", inline: "nearest" });
  }
  scrollToBottom(){
    const i = this.selectedLot['hours'].length
    const element = document.getElementById(`hour${i}`);
    element.scrollIntoView({ behavior: "smooth", inline: "nearest" });
  }
  ngAfterViewInit(){
    if(this.refresh==undefined){
      this.ngOnChanges()
    }
    
  }
  ngOnChanges(){
    this.ngOnDestroy()
    
    if(this.platform.is('android') && Capacitor.isNativePlatform()){
      this.showAlert()
    } else {
      this.loadData()
    }
    
    
    
  }
  loadData(){
      
    this.lots=undefined
    this.selectedLot=undefined
    
    
      this.dataSRV.getData('api/permits/temporary/map')
    .pipe(map((data:any)=>{
      if(data?.lots){
        data?.lots.forEach(lot => {
        
        for(var i=0;i<lot?.hours.length;i++){
          if(parseFloat(lot?.hours[i].price)==0 && !this.dataSRV.settings.payments.enable_zero_dollar){
            lot?.hours.splice(i,1)
          } else {
            lot.hours[i].price=parseFloat(lot?.hours[i]?.price)
          }
        }
         
          
        });
      }
      
     
      
      return data
    }))
    .subscribe({
      next:async (data:any)=>{
       
        if(data?.status=='success'){
          if(data?.lots.length>0){
            this.selectedLot= data['lots'][0]
        if (this.selectedLot['hours'].length < 1) {
          this.disableHourly = true;
          this.permitType='daily'
        } else {
          this.disableHourly = false;
        }
        if(this.selectedLot['daily']==null || parseFloat(this.selectedLot['daily'])==0 && !this.dataSRV.settings.payments.enable_zero_dollar){
          this.disableDaily = true;
          this.permitType='hourly'
        } else {
          this.disableDaily = false;
        }
        this.lots = data['lots']
        this.loaded=true
        this.chart = new Chart(this.barCanvas.nativeElement, {
          type: 'pie',
          data: {
            labels: ['% ' + this.translate.instant('keys.data.permits.available'),'% ' + this.translate.instant('keys.data.common.rented')],
            datasets: [{
             
              data: [data['lots'][0]['stats']['tempFreePercent'], data['lots'][0]['stats']['tempBookedPercent']],
              backgroundColor: [
                'rgb(60, 179, 113)',
                'rgb(255, 0, 0)',
               
              ],
              
              hoverOffset: 4
            }]
          },
          options:{
            responsive:true,
            maintainAspectRatio:false,
            rotation: -90,
            circumference: 180,
          }
        });
        this.loaded=true
        try{
          get("https://maps.googleapis.com/maps/api/js?key="+ this.mapsApiKey, async () => {
        await Geolocation.checkPermissions().then(async permission=>{
          
          if(Capacitor.isNativePlatform()){
              if(permission.location=='prompt' || permission.location=='prompt-with-rationale'){
            await Geolocation.requestPermissions().then(async permission =>{
             
              if(permission.location=='granted'){
                await Geolocation.getCurrentPosition(this.options).then(async position=>{
                  var coords = {
                    latitude : position.coords.latitude,
                    longitude : position.coords.longitude
                  }
                  this.createMapForNative(data,coords)
                }).catch(err=>{
                 this.errorHandlerSRV.displayErrorMessage(err,true)
                  
                })
              } else {
                var clientAddress = this.dataSRV.settings?.system?.company_address;
                var geocoder = new google.maps.Geocoder();
                await geocoder.geocode( {address:clientAddress}).then(async position=>{
                  var coords = {
                    latitude : position.results[0].geometry.location.toJSON().lat,
                    longitude : position.results[0].geometry.location.toJSON().lng
                  }
                  this.createMapForNative(data,coords)
              })
              }
            }).catch(err=>{
             this.errorHandlerSRV.displayErrorMessage(err,true)
              
            })
          }
          if(permission.location=='granted'){
            await Geolocation.getCurrentPosition(this.options).then(async position=>{
              var coords = {
                latitude : position.coords.latitude,
                longitude : position.coords.longitude
              }
              this.createMapForNative(data,coords)
            }).catch(err=>{
             this.errorHandlerSRV.displayErrorMessage(err,true)
              
            })
          }
          } else {
            //web is different, it will automatically ask for location permission
            await Geolocation.getCurrentPosition(this.options).then(async position=>{
              var coords = {
                latitude : position.coords.latitude,
                longitude : position.coords.longitude
              }
              this.createMapForWeb(data,coords)
              
            }).catch(async err=>{ // if user denies permission on web, use client's address
              var clientAddress = this.dataSRV.settings?.system?.company_address;
                var geocoder = new google.maps.Geocoder();
                await geocoder.geocode( {address:clientAddress}).then(async position=>{
                  var coords = {
                    latitude : position.results[0].geometry.location.toJSON().lat,
                    longitude : position.results[0].geometry.location.toJSON().lng
                  }
                  this.createMapForWeb(data,coords)
        })
              
            })
          }
          
        
        }).catch(async err=>{ //if location is turned off - android
          this.errorHandlerSRV.displayErrorMessage(err,true)
          var clientAddress = this.dataSRV.settings?.system?.company_address;
                var geocoder = new google.maps.Geocoder();
                await geocoder.geocode( {address:clientAddress}).then(async position=>{
                  
                  var coords = {
                    latitude : position.results[0].geometry.location.toJSON().lat,
                    longitude : position.results[0].geometry.location.toJSON().lng
                  }
                  if(Capacitor.isNativePlatform()){
                    this.createMapForNative(data,coords)
                  } else {
                    this.createMapForWeb(data,coords)
                  }
                  
              })
          
        })
      })
        } catch (err){
          this.errorHandlerSRV.displayErrorMessage(err,true)
        }
          }
          else {
            const alert = await this.alertCtrl.create({
              message: this.translateService.instant('keys.data.permits.no_lots_on_map') || 'There are no lots marked on the parking availability map',
              backdropDismiss:false,
              buttons: [
       
                {
                  text:  this.translateService.instant('keys.data.common.back') || 'Back',
                  handler: () => {
                    this.location.back()
                  }
                }
              ]
            });
        
            await alert.present();
          }
        } else {
          this.errorHandlerSRV.displayErrorMessage(data,true)
        }
        
       
      },
      error:err=>{
        this.errorHandlerSRV.displayErrorMessage(err,true)
      }
      })
     
      
     
  }
 
  async createMapForWeb(data,coords){
      
        this.map = await GoogleMap.create({
          id:'fc6a1a9b2e63fff7',
          apiKey: this.mapsApiKey,
          element:this.mapRef.nativeElement,
          forceCreate:true,
          config:{
            center:{
              lat:coords.latitude,
              lng:coords.longitude
            },
            zoom:17,
            mapTypeId: "terrain",
            disableDefaultUI: true,
            styles:this.webMapStyles
          }
          
        })
        this.addMarkers(coords,data)
        this.moveCamera(this.selectedLot.lat,this.selectedLot.lng,16)
       
   
    
  
    
    

    
   
     
   
    
  
   
   
    
  }
  async createMapForNative(data,coords){
          this.map = await GoogleMap.create({
       
            id:'fc6a1a9b2e63fff7',
            apiKey: this.mapsApiKey,
            element:this.mapRef.nativeElement,
            forceCreate:true,
            config:{
              center:{
                lat:coords.latitude,
                lng:coords.longitude
              },
              zoom:17,
              styles:this.nativeMapStyles
             
             
            }
          })
          await this.map.setMapType(MapType.Terrain)
          this.addMarkers(coords,data)
          this.color='transparent'
          this.moveCamera(this.selectedLot.lat,this.selectedLot.lng,16)
      
   }
  async moveCamera(lat,lng,zoom){
    await this.map.setCamera({
      coordinate: {
        lat: lat,
        lng: lng,
      },
      zoom: zoom
    });
    this.changeDetectorRef.detectChanges();
  }
  selected(event){
   this.selectedLot = this.lots.find(lot=>event.detail.value==lot['id']);
  
   if (this.selectedLot['hours'].length < 1) {
    this.disableHourly = true;
    this.permitType='daily'
  } else {
    this.disableHourly = false;
  }
  if(this.selectedLot['daily']==null || parseFloat(this.selectedLot['daily'])==0 && !this.dataSRV.settings.payments.enable_zero_dollar){
    this.disableDaily = true;
    this.permitType='hourly'
  } else {
    this.disableDaily = false;
  }
 
  
   this.chart.destroy()
   this.chart = new Chart(this.barCanvas.nativeElement, {
    type: 'pie',
    data: {
      labels: ['% ' + this.translate.instant('keys.data.permits.available'),'% ' + this.translate.instant('keys.data.common.rented')],
      datasets: [{
       
        data: [this.selectedLot['stats']['tempFreePercent'], this.selectedLot['stats']['tempBookedPercent']],
        backgroundColor: [
          'rgb(60, 179, 113)',
          'rgb(255, 0, 0)',
         
        ],
        
        hoverOffset: 4
      }],
      
    },
    options:{
      responsive:true,
      maintainAspectRatio:false,
      rotation: -90,
      circumference: 180,
    }
  });
   
    this.moveCamera(this.selectedLot.lat,this.selectedLot.lng,18)
   
    
  }
  async addMarkers(location,data?){
   
   
    var markers:Marker[]=[]
    data.lots.forEach(lotData=>{
      var marker = {
        coordinate:{
          lat:lotData['lat'],
          lng:lotData['lng']
        },
        title:lotData['name'],
        iconSize:{
          width: 45,
          height: 45
        },
        snippet:lotData['location'],
        iconUrl:`${this.dataSRV.apiUrl}/images/parking/icons/parking-sign-40-${lotData.color}.png`
        
      }
      markers.push(marker)
    })
    // markers.push({
    //   coordinate:{
    //     lat:location.latitude,
    //     lng:location.longitude
    //   },
    //   title:"your location",
    //   iconSize:{
    //     width: 50,
    //     height: 50
    //   },
    //   
    //   iconUrl:"assets/icon/map-marker.png"
    // })
    this.markers= await this.map.addMarkers(markers)
    
    
    
    
    this.map.setOnMarkerClickListener(async(marker)=>{
      // if(marker.title!="your location"){
        this.selectedLot= this.lots.find(lot=>marker.title==lot['name'])
        if (this.selectedLot['hours'].length < 1) {
          this.disableHourly = true;
          this.permitType='daily'
        } else {
          this.disableHourly = false;
        }
        if(this.selectedLot['daily']==null || parseFloat(this.selectedLot['daily'])==0 && !this.dataSRV.settings.payments.enable_zero_dollar){
          this.disableDaily = true;
          this.permitType='hourly'
        } else {
          this.disableDaily = false;
        }
        this.chart.destroy()
     this.chart = new Chart(this.barCanvas.nativeElement, {
      type: 'pie',
      data: {
        labels: ['available','rented'],
        datasets: [{
         
          data: [this.selectedLot['stats']['tempFreePercent'], this.selectedLot['stats']['tempBookedPercent']],
          backgroundColor: [
            'rgb(60, 179, 113)',
            'rgb(255, 0, 0)',
           
          ],
          
          hoverOffset: 4
        }],
        
      },
      options:{
        responsive:true,
        maintainAspectRatio:false,
        rotation: -90,
    circumference: 180,
      }
    });
     
      this.moveCamera(this.selectedLot.lat,this.selectedLot.lng,18)
      // }
      this.changeDetectorRef.detectChanges();
     
    })
  }
  locateMe(){
    Geolocation.getCurrentPosition(this.options).then(async position=>{
      this.map.removeMarkers(this.markers)
      this.moveCamera(position.coords.latitude,position.coords.longitude,18)
      this.addMarkers(position.coords)
    })
   
  }

}
